import { RESET_RESPONSE_POLICY } from "../ErrorResponse/types";
import {
  GET_POLICY_DETAILS,
  SAVE_PAYMENT,
  GET_POLICY_INVOKE,
  Payload_entry,
  SET_UPI_ASBA_FLAG,
  SET_USER_TYPE,
  SET_TOKEN_MIS,
  SET_USER_DATA
} from "./types";
const initialState = {
  savePaymentDetails: {},
  getPolicyHit: false,
  name: "",
  transactionId: null,
  isUpiAsba: false,
  tokenMis: null,
  userType: "",
  userData:{}
};

const renewalReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_POLICY_DETAILS:
      return {
        ...state,
        ...payload,
        ...{
          name: `${payload?.firstName ?? ""} ${payload?.middleName ?? ""} ${
            payload?.lastName ?? ""
          }`,
        },
      };
    case Payload_entry:
      return { ...state, ...payload };
    case SAVE_PAYMENT:
      return {
        ...state,
        ...{ savePaymentDetails: { ...payload } },
      };
    case GET_POLICY_INVOKE:
      return {
        ...state,
        ...{ getPolicyHit: payload },
      };
    case SET_UPI_ASBA_FLAG:
      return {
        ...state,
        ...{ isUpiAsba: payload },
      };
    case SET_TOKEN_MIS:
      return {
        ...state,
        ...{ tokenMis: payload },
      };
    case SET_USER_TYPE:
      return {
        ...state,
        ...{ userType: payload },
      };
    case SET_USER_DATA:
      return {
        ...state,
        ...{ userData: payload },
      };
    case RESET_RESPONSE_POLICY:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default renewalReducer;
